<template>
  <div class="c-app">
    <Sidebar :key="locale" />
    <CWrapper>
      <Header />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view />
            </transition>
          </CContainer>
        </main>
        <Footer />
        <UserLoading v-if="loading" />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import UserLoading from "@/components/Loading";
import { mapState } from "vuex";

export default {
  name: "MainLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    UserLoading
  },
  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    }),
    locale: function() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/portal.scss";
.c-main {
  background-color: #F9FAFC;
}
@media only screen and (max-device-width: 1024px) {
  .c-wrapper {
    overflow-x: hidden;
  }
  .container-fluid {
    padding: 0 10px !important;
  }
}
</style>
